import React from "react";
import { FleetrifyModal } from "../../../Modal/modal";
import { FleetrifyButton } from "../../../Button/customButton";

export interface ColumnConfig {
  label: string;
  key: string;
}

interface PreviewModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  title?: string;
  columns: ColumnConfig[];
  rows: Record<string, any>[];
  onConfirm: () => void;
  confirmLabel?: string;
  isLoading?: boolean;
}

const PreviewModal = ({
  isOpen,
  setIsOpen,
  title = "Preview",
  columns,
  rows,
  onConfirm,
  confirmLabel = "Confirm",
  isLoading = false,
}: PreviewModalProps) => {
  return (
    <FleetrifyModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={title}
      className="max-w-4xl h-fit"
    >
      <div className="p-6">
        {/* Table Preview */}
        <div className="overflow-x-auto mt-4 max-h-[400px] overflow-y-auto">
          <table className="w-full border border-gray-200 rounded-lg">
            <thead className="bg-[#F8FAFC] text-sm font-semibold text-[#00032A]">
              <tr>
                {columns.map((col) => (
                  <th key={col.key} className="px-4 py-2 text-left">
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-[13px] text-[#00032A]">
              {rows.length > 0 ? (
                rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-t last:border-b hover:bg-gray-50 transition-colors"
                  >
                    {columns.map((col) => (
                      <td key={col.key} className="px-4 py-2">
                        {row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="px-4 py-6 text-center text-gray-400 italic"
                  >
                    No data to preview
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer Buttons */}
        <div className="flex gap-3 justify-end mt-6">
          <FleetrifyButton
            onClick={() => setIsOpen(false)}
            className="border !py-[10px] px-[24px] bg-transparent border-gray-300 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </FleetrifyButton>
          <FleetrifyButton
            loading={isLoading}
            onClick={onConfirm}
            className="bg-[#143887] text-white px-[24px] !py-[10px] hover:bg-[#0f2c66]"
          >
            {confirmLabel}
          </FleetrifyButton>
        </div>
      </div>
    </FleetrifyModal>
  );
};

export default PreviewModal;
